module.exports = __webpack_public_path__ + "img/frank_groenewegen.0ed6dfc4.jpg";